<router-outlet />

<ln-analytics-consent-banner />
